<div class="flex flex-col items-center gap-6 text-center">
  <!-- Warning Icon -->
  <div class="flex h-24 w-24 items-center justify-center rounded-full bg-amber-100 text-amber-600">
    <dojo-icon [icon]="'triangle-exclamation'" [size]="48" />
  </div>

  <!-- Warning Message -->
  <div class="max-w-md space-y-4">
    <h1 class="text-2xl font-bold text-gray-900">Access Restricted</h1>
    <p class="text-lg text-gray-600">
      You don't have the required administrator permissions to access this content management system.
    </p>
    <p class="text-sm text-gray-500">Please contact your system administrator if you believe this is an error.</p>
  </div>

  <!-- Sign Out Button -->
  <dojo-button (click)="signOut()" [fill]="'outline'" [size]="'l'">
    <dojo-icon [icon]="'arrow-right-from-bracket'" class="mr-2" />
    <span>{{ 'examdojo.registration.sign_out' | transloco }}</span>
  </dojo-button>
</div>
